// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__1x5JI","logo":"MainNavigation_logo__V3Gl7","nav":"MainNavigation_nav__1ZDzK","active":"MainNavigation_active__1o1JY"};